import { Avatar } from '@mui/material';

export const UserAvatar = () => (
    <Avatar id="user-avatar" sx={{ width: 32, height: 32 }} />
);
